import { render, staticRenderFns } from "./OrderVerifyM.vue?vue&type=template&id=13f32846&scoped=true"
import script from "./OrderVerifyM.vue?vue&type=script&lang=js"
export * from "./OrderVerifyM.vue?vue&type=script&lang=js"
import style0 from "./OrderVerifyM.vue?vue&type=style&index=0&id=13f32846&prod&lang=scss&scoped=true"
import style1 from "./OrderVerifyM.vue?vue&type=style&index=1&id=13f32846&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f32846",
  null
  
)

export default component.exports